var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"text-page"}},[_c('h1',{staticClass:"page-title txt-black"},[_vm._v("Política de envío, devolución y reembolso")]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.body)}})])}
var staticRenderFns = []

export { render, staticRenderFns }